
import React from 'react';
import Opt from '../../../hooks/opt.js';

    /*
     * Generic helper components and methods
     */
    export const Helpers = {
      SortHandle: class extends React.Component {
          render() {
            if (this.props.icon) {
              return (
                <div className="sort-handle" onMouseDown={this.startDrag.bind(this)}>
                  <i className={this.props.icon}></i>
                </div>
              );
            }
            return (
              <div className="sort-handle" onMouseDown={this.startDrag.bind(this)}>
                <div className="up"></div>
                <div className="handle icon-grid"></div>
                <div className="down"></div>
              </div>
            );
          }
          startDrag(event) {
              if (this.props.startDragCallback) {
                  this.props.startDragCallback(event);
              }
              event.stopPropagation();
          }
      },
      DropArea: class extends React.Component {
          render() {
              return (
                  <div className="drop-area" style={{ display: "flex", alignItems: "center", justifyContent: "center", ...(this.props.style || {})}} data-component-id={this.props.componentId} data-context={this.props.context}>
                      {(this.props.textContent || I18n.t('drag_and_drop_a_component', {scope: 'fe'}))}
                  </div>
              );
          }
      },
      convertValue: function(str, type) {
          switch(type){
              case 'integer':
                  return parseInt(str);
              case 'decimal':
                  return parseFloat(str);
              case 'date':
                  return Date.parse(str);
              default:
                  return str;
          }
      },
      simpleFormat: function(str) {
          str = jQuery('<div/>').text(str).html(); // escape html
          str = str.replace(/\r\n?/g, "\n");
          str = jQuery.trim(str);

          if (str.length > 0) {
              str = str.replace(/\n\n/g, '</p><p>');
              str = str.replace(/\n/g, '<br />');
              str = '<p>' + str + '</p>';
          }
          return str;
      },
      linkURLs: function(str) {
          if (typeof Autolinker !== 'undefined') {
              return Autolinker.link(str, {
                  stripPrefix: {scheme: true, www: false}
              });
          }
          return str;
      },
      randomString: function(length) {
          var chars = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
          var s = '';
          for (var i = 0; i < (length || 8); i++) {
              var pos = Math.floor(Math.random() * chars.length);
              s += chars.substring(pos, pos + 1);
          }
          return s;
      },
      setObjectValue: function(obj, attrs, value) {
          if (attrs.length > 1) {
              obj[attrs[0]] = obj[attrs[0]] || {};
              obj = obj[attrs.shift()];
              this.setObjectValue(obj, attrs, value);
          } else {
              obj[attrs.shift()] = value;
          }
      },
      getObjectValue: function(obj, attrs) {
          var value = obj;

          (attrs || []).forEach(function(attr, i) {
              value = value[attr];

              if (i < attrs.length - 1) {
                  value = value || {};
              }
          });
          return value;
      },
      fullFieldName: function(fieldScope, repeatedFieldScope, field_name,  isArray, prefix) {
        let name = `${field_name}${prefix || ""}`;

        if (repeatedFieldScope) {
            name = repeatedFieldScope + '[' + name + ']';
        }
        if (fieldScope) {
            name = fieldScope + '[' + name + ']';
        }
        if (isArray) {
            name += '[]';
        }
        return name;
      },
      fieldNamePath: function(fullFieldName, fieldScope) {
        return fullFieldName.split(/[\[\]]+/).filter((s) => (['', fieldScope].indexOf(s) == -1))
      },
      getText(translations, key, language, fallback = '') {
          return ((translations || {})[language] || (translations || {})[Object.keys((translations || {}))[0]] || (translations || {}).en || {})[key] || fallback;
      },
      TextareaCounter: class {
          constructor(textarea, options) {
              this.area = jQuery(textarea);
              this.options = options || {};
              this.options.type = this.options.type || 'char'; // word | char
              this.options.limit = this.options.limit || this.area.attr('data-counter-limit') || 0;
              this.options.allowExceeding = this.options.allowExceeding ? true : false;

              this.updateCounter = this.updateCounter.bind(this);
              this.initDisplay();
              this.updateCounter();
              this.area.on('keyup', this.updateCounter);
              this.area.on('paste', function() {
                  // Small timeout on paste is required for the pasted content to be
                  // in place before updating the counter.
                  setTimeout(this.updateCounter, 100);
              }.bind(this));
          }
          static remove(textarea) {
              jQuery(textarea).off('keyup').off('paste').prev('.textarea-counter-count').remove();
          }
          initDisplay() {
              var label = this.options.hideLabel ? '' : (this.options.type == 'word' ? I18n.t('words', {scope: 'fe'}) : I18n.t('characters', {scope: 'fe'}));

              if (this.area.prev('.textarea-counter-count').length == 0) {
                  this.area.before('<span class="textarea-counter-count"><span class="label label-default"><span class="current">0</span> / <span class="limit">0</span> ' + label + '</span></span>');
              }
              this.display = this.area.prev('.textarea-counter-count');
              this.display.find('.limit').html(this.options.limit);
          }
          updateCounter() {
              if (this.options.type == 'word') {
                  var text = this.area.val().replace(/^\s+/, '').replace(/\s+$/, '');
                  var words = (text.length == 0 ? [] : text.split(/\s+/));

                  this.currentCount = words.length;

                  if (this.currentCount > this.options.limit && this.options.allowExceeding !== true) {
                      var regex = new RegExp('^((\\s*[\\S]+\\s+){0,' + this.options.limit + '}).+');
                      this.area.val(this.area.val().match(regex)[1]);
                      this.currentCount = this.options.limit;
                  }
              } else { // char
                  this.currentCount = (this.area.val() ? this.area.val().length : 0)

                  if (this.currentCount > this.options.limit && this.options.allowExceeding !== true) {
                      this.area.val(this.area.val().slice(0, this.options.limit));
                      this.currentCount--;
                      this.display.find('span.label').removeClass('label-default').addClass('label-info');
                      return false;
                  }
              }

              if (this.currentCount < this.options.limit) {
                  this.display.find('span.label').removeClass('label-info').addClass('label-default');
              } else {
                  this.display.find('span.label').removeClass('label-default').addClass('label-info');
              }
              this.display.find('.current').html(this.currentCount);

              return true;
          }
      },
      CurrencyFormatter: class {
          constructor(textarea, options) {
              this.area = jQuery(textarea);
              this.format = options.format;

              this.inputName = this.area.attr('name');

              // Add hidden input if doesn't exist
              if (this.inputName) {
                  this.hiddenInput = jQuery('<input type="hidden" name="' + this.inputName + '" />');
                  this.area.parent().append(this.hiddenInput);
                  this.area.attr('name', '');
              } else {
                  this.hiddenInput = this.area.parent().find('input[type="hidden"]');
                  this.inputName = this.hiddenInput.attr('name');
              }

              this.toCurrency = this.toCurrency.bind(this);
              this.toEditable = this.toEditable.bind(this);
              this.toCurrency();

              if (!options.readOnly) {
                  this.area.on('change', this.toEditable);
                  this.area.on('focus', this.toEditable);
              }
          }
          static remove(textarea) {
              const hiddenInput = jQuery(textarea).parent().find('input[type="hidden"]');
              if (hiddenInput.length) {
                  hiddenInput.remove();
              }
          }
          toCurrency() {
              var value = this.removeSeparators(this.area.val(), this.format);
              this.hiddenInput.val(value);
              this.area.val(this.addSeparators(value, this.format));
          }
          toEditable() {
              this.area.val(this.removeSeparators(this.area.val(), this.format));
          }
          toSaveable() {
              this.area.val(this.removeSeparators(this.area.val(), this.format));
          }
          addSeparators(value, format) {
              value = value.toString().split(".");
              var separator = this.getSeparator(format);
              var integer_part = value[0].replace(/\B(?=(\d{3})+(?!\d))/g, separator.thousand);
              if (value.length > 1)
                  return `${integer_part}${separator.decimal}${value[1]}`;
              else
                return integer_part;
          }
          removeSeparators(value, format) {
              var separator = this.getSeparator(format);
              value = (value ?? '').toString().replace(/ /g, '');
              var re = new RegExp('\\' + '.', 'g');

              var dots = value.split('.').length - 1;
              var commas = value.split(',').length - 1;

              if (dots > 1) {
                  value = value.toString().replace(re, '');
              }

              if (commas > 1) {
                  value = value.toString().replace(/,/g, '');
              }

              if (dots == 1 && commas == 1) {
                  if (value.indexOf('.') < value.indexOf(',')) {
                      value = value.toString().replace(re, '');
                      value = value.toString().replace(/,/g, separator.decimal);
                  } else {
                      value = value.toString().replace(/,/g, '');
                      value = value.toString().replace(re, separator.decimal);
                  }
              } else if (dots == 1) {
                  if(separator.thousand === '.'){
                      value = value.toString().replace(re, '');
                  }else{
                      value = value.toString().replace(re, separator.decimal);
                  }
              } else if (commas == 1) {
                  if(separator.thousand === ','){
                      value = value.toString().replace(/,/g, '');
                  }else{
                      value = value.toString().replace(/,/g, separator.decimal);
                  }
              }

              return value;
          }
          getSeparator(format) {
              switch(format) {
                  case 'default':
                      return  {
                          thousand: ' ',
                          decimal: '.'
                      };
                  case 'format_1':
                      return  {
                          thousand: ' ',
                          decimal: ','
                      };
                  case 'format_2':
                      return  {
                          thousand: ',',
                          decimal: '.'
                      };
                  case 'format_3':
                      return  {
                          thousand: '.',
                          decimal: ','
                      };
                  default:
                      return  {
                          thousand: ' ',
                          decimal: '.'
                      };
              }
          }
      },
      Option: class {
        static getOptionText(o, c, language) {
            if (c.useOptionLibrary && c.useOptionSetHierarchy) {
                return Opt.t({
                    scope: o.option_set_key || Opt.scopeFromValue(o.value),
                    value: Opt.unscopedValue(o.value),
                    locale: language
                });
            } else if (c.useOptionLibrary) {
                return Opt.t({ scope: c.optionSetKey, value: o.value, locale: language});
            } else {
                return o.label || o.value;
            }
        }
    
        static getComponentHierarchyOptions(component, optionSetHierarchyValues, language) {
            const options = optionSetHierarchyValues[component.optionSetHierarchyKey] || [];

            const level = isNaN(Number(component.optionSetHierarchyLevel)) ? 0 : Number(component.optionSetHierarchyLevel) - 1;

            const levelOptions = options.filter(o => o.level === level);

            const mapOption = o => ({ value: o.value, label: Helpers.Option.getOptionText(o, component, language), level: o.level, option_set_key: o.option_set_key });

            return levelOptions.map(mapOption);
        }

        static getOptionSetComponentOptions(component, optionSetValues, optionSetHierarchyValues, language) {
            if (component.useOptionSetHierarchy) {
                return Helpers.Option.getComponentHierarchyOptions(component, optionSetHierarchyValues, language)
            }
            return optionSetValues?.[component.optionSetKey] || [];
        }
      }
}

export default Helpers;